var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 205,
    viewBox: "0 0 208 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.8497 203.985L106.141 200.049L81.3686 193.488V190.863L82.6724 189.551L108.748 186.927H120.483L147.862 189.551H159.596L168.723 193.488H206.533L197.407 110.819L190.888 87.2V71.4537L180.457 58.3317L172.634 42.5854L153.078 29.4635L143.951 25.5269L127.002 8.46838L106.141 0.595215L94.4066 15.0293L85.28 18.9659L72.2421 25.5269L67.0269 29.4635L56.5965 49.1464L40.9509 58.3317L27.913 79.3268L20.0902 87.2L14.875 110.819L5.74839 131.815L0.533203 193.488L26.6092 200.049H56.5965L74.8497 203.985Z",
    fill: "url(#paint0_linear_363_194)",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3485 186.928L30.5257 151.499L26.6143 169.87L25.3105 179.055L30.5257 185.616L38.3485 186.928Z",
    fill: "white",
    stroke: "url(#paint1_linear_363_194)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5866 39.9604V29.4629L77.46 39.9604L69.6372 62.2677L61.8144 64.8921L46.1688 84.575L42.2574 99.0091L33.1309 126.565L53.9916 102.946V106.882L52.6878 133.126L48.7764 154.121L56.5992 185.614L70.941 192.175L63.1182 152.809L69.6372 131.814L70.941 120.004L73.5486 112.131L82.6752 101.634L93.1055 72.7653L106.144 63.5799H115.27H133.523L146.561 72.7653L155.688 79.3262L172.637 108.194L179.156 129.19V142.312L175.245 133.126L162.207 110.819L167.422 138.375V161.994L170.03 181.677H176.549L179.156 158.058L197.409 181.677L186.979 116.068L181.764 108.194L170.03 78.014L162.207 71.4531L158.295 66.2043L153.08 53.0824L145.257 45.2092L128.308 38.6482L120.485 33.3995L115.27 39.9604L87.8904 63.5799L76.1562 87.1994L67.0296 96.3848L74.8524 75.3897C74.8524 58.5936 82.6752 44.7718 86.5866 39.9604Z",
    fill: "white",
    stroke: "url(#paint2_linear_363_194)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_363_194",
    x1: 103.533,
    y1: 0.595215,
    x2: 103.533,
    y2: 203.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673077,
    stopColor: "#031927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966346
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_363_194",
    x1: 31.8295,
    y1: 151.499,
    x2: 31.8295,
    y2: 186.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673077,
    stopColor: "#031927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966346
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_363_194",
    x1: 115.27,
    y1: 29.4629,
    x2: 115.27,
    y2: 192.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673077,
    stopColor: "#031927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966346
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7c30f1cdce1542ca8d5ea67d367b27cd.svg";
export { ForwardRef as ReactComponent };